import { api } from '../../apiClient';

// Payment API service functions
export const paymentService = {
  // Create Razorpay order
  createOrder: async (orderData) => {
    const response = await api.post('/payment/create-order', orderData);
    return response.data;
  },

  // Verify payment
  verifyPayment: async (paymentData) => {
    const response = await api.post('/payment/verify-payment', paymentData);
    return response.data;
  },

  // Handle payment success
  handlePaymentSuccess: async (paymentData) => {
    const response = await api.post('/payment/payment-success', paymentData);
    return response.data;
  },

  // Handle payment failure
  handlePaymentFailure: async (paymentData) => {
    const response = await api.post('/payment/payment-failed', paymentData);
    return response.data;
  },

  // Get payment status
  getPaymentStatus: async (orderId) => {
    const response = await api.get(`/payment/status/${orderId}`);
    return response.data;
  },
};

export default paymentService;
